'use strict';

angular.module('cgmemApp')
  .controller('CourtReservationCtrl', function ($scope, $state, $stateParams, $uibModal, $q, $log, $window, $timeout,
      AppConfig, WorkingAccount, User, Logger) {
    $scope.loading = true;
    $scope.eligible = true;
    $scope.autoRedirect = $stateParams.autoRedirect;

    $q.all([AppConfig.get(), WorkingAccount.get(), User.get()])
      .then(function (r) {
        $scope.loading = false;
        var appConfig = r[0];
        var workingAcct = r[1];
        var user = r[2];
        $scope.config = appConfig?.courtReservations;

        if (!workingAcct.account.sMS || !workingAcct.account.sMS[appConfig.season] || user.nonMember) {
          $scope.eligible = false;
        }
      })
      .catch(function(err) {
        $log.error(err);
      });
  });
